import { SiteIdOverrideConfig } from "stores/wizard/config";
import { timeValues24HoursFormat } from "src/components/shared/TimeDropdown/config/time/timeValues";

export const siteId16: SiteIdOverrideConfig = {
  package: {
    showAllSubLOB: false,
  },
  car: {
    date: {
      queryParam: {
        start: "",
        end: "",
      },
    },
    form: {
      action: "https://rent-a-car.expedia.co.kr/{locale}-kr/book#/vehicles",
    },
    timeValues: timeValues24HoursFormat,
    defaultShowingTime: "10:30",
    carType: "CARTRAWLER",
    clientID: 312054,
    residenceID: "KR",
  },
};
